// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1IXFG","rootSmall":"AddTileButton_rootSmall__3SA9V"};